module.exports = __webpack_public_path__ + "img/Mudah@2x.9535a67f.png";